import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'utils/axiosBaseQuery';

// Define a service using a base URL and expected endpoints
export const currencyApi = createApi({
  reducerPath: 'currencyApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['currency'],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getCurrencyList: builder.query({
      query: () => ({
        method: 'GET',
        path: `CurrencyNames`,
      }),
      providesTags: ['currency'],
    }),
    createCurrency: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'POST',
        path: 'CurrencyNames',
      }),
      invalidatesTags: ['currency'],
    }),
    UpdateCurrency: builder.mutation({
      query: ({ data, id }) => ({
        data,
        method: 'PUT',
        path: `CurrencyNames/${id}`,
      }),
      invalidatesTags: ['currency'],
    }),
    DeleteCurrency: builder.mutation({
      query: ({ id }) => ({
        method: 'DELETE',
        path: `CurrencyNames/${id}`,
      }),
      invalidatesTags: ['currency'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const currencyApiReducerName = currencyApi.reducerPath;
export const currencyApiReducer = currencyApi.reducer;
export const currencyApiMiddleware = currencyApi.middleware;

export const {
  useGetCurrencyListQuery,
  useCreateCurrencyMutation,
  useUpdateCurrencyMutation,
  useDeleteCurrencyMutation,
} = currencyApi;
